import React from "react";
import settingable from "fantastic/components/hoc/settingable";
import SingleNumberSetting from "fantastic/components/common/controls/SingleNumberSetting";
import ToggleSetting from "fantastic/components/common/controls/ToggleSetting";
import BorderSettings from "fantastic/components/common/controls/border/Settings";
import SingleStringSetting from "fantastic/components/common/controls/SingleStringSetting";
import BorderRadius from "fantastic/components/common/controls/border/BorderRadius";

const SectionSettings = ({
  selected,
  update,
  selectedNode: {
    full_width,
    border_radius,
    border_color,
    border_style,
    border_width,
    src = "",
    contents,
  },
  scrollToIfNeeded
}) => {

  const onChange = (field, value) => {
    update(selected, { [field]: value });
  };

  const fullWidthParams = {
    onChange,
    label: i18n.t('background_full_width'),
    field: 'full_width',
    value: full_width
  };

  const borderParams = {
    onChange,
    scrollToIfNeeded,
    color: { field: "border_color", value: border_color },
    style: { field: "border_style", value: border_style },
    size: { field: "border_width", value: border_width, max: 6 }
  };

  const borderRadiusParams = {
    displayInput: false,
    min: 0,
    max: 300,
    step: 1,
    value: border_radius,
    onChange: (value) => onChange('border_radius', value)
  };

  const hasLiquidTags = JSON.stringify(contents).includes('{{');

  return (
    <div>
      <ToggleSetting {...fullWidthParams} />
      <BorderRadius {...borderRadiusParams} />
      <BorderSettings {...borderParams} />
      { hasLiquidTags &&
        <SingleStringSetting
          value={src}
          onChange={(value) => onChange('src', value)}
          label={i18n.t('products')}
          placeholder={i18n.t('products_placeholder')}
        />
      }
    </div>
  );
};

export default settingable("background", "visibility", "padding")(SectionSettings);
